import React from 'react';
import styles from './AdOpeningHours.module.scss';
import WatchLaterRoundedIcon from '@material-ui/icons/WatchLaterRounded';
import FiberManualRecordRoundedIcon from '@material-ui/icons/FiberManualRecordRounded';
import FiberManualRecordOutlinedIcon from '@material-ui/icons/FiberManualRecordOutlined';
import GenericDetail
  from 'gui/components/listPage/components/ad/components/genericDetail';
import {IPlaceDetails} from "data/interfaces/products";
import classNames from "classnames";

const dayOfWeekNames = [
  'ראשון',
  'שני',
  'שלישי',
  'רביעי',
  'חמישי',
  'שישי',
  'שבת',
];


interface IAdOpeningHoursProps {
  placeDetails: IPlaceDetails | IPlaceDetails[];
}

const splitPeriodTimeHourMinute = t => ({hour: parseInt(t.slice(0, 2), 10), minute: parseInt(t.slice(2, 4), 10)});
const getSplitIsraelHourMinute = () => {
  const israelTime = new Date();
  const israelHours = israelTime.toLocaleString('he-IL', {hour: '2-digit', hour12: false, timeZone: 'Asia/Jerusalem'});
  const israelMinute = israelTime.toLocaleString('he-IL', {
    minute: '2-digit',
    hour12: false,
    timeZone: 'Asia/Jerusalem'
  });
  return ({hour: parseInt(israelHours, 10), minute: parseInt(israelMinute, 10)});
};
const convertToTotalTimeSinceMidnight = (hourMinute) => {
  return hourMinute.hour * 60 * 60 + hourMinute.minute * 60;
};
const formatPeriodTime = t => {
  t = splitPeriodTimeHourMinute(t);
  return [t.hour, t.minute]
    .map(t => {
      t = `${t}`;
      while (t.length < 2) {
        t = '0' + t;
      }
      return t;
    })
    .join(':');
};

const isSameDayToday = (day) => {
  const israelTime = new Date();
  const israelDay = israelTime.toLocaleString('he-IL', {weekday: 'narrow', hour12: false, timeZone: 'Asia/Jerusalem'});
  const currentDay = israelTime.getDay();
  const distance = day - currentDay;
  israelTime.setDate(israelTime.getDate() + distance);
  const anyTimeDay = israelTime.toLocaleString('he-IL', {weekday: 'narrow', hour12: false, timeZone: 'Asia/Jerusalem'});
  return anyTimeDay === israelDay;
};

const isOpen = (startTime, endTime) => {
  startTime = convertToTotalTimeSinceMidnight(splitPeriodTimeHourMinute(startTime));
  endTime = convertToTotalTimeSinceMidnight(splitPeriodTimeHourMinute(endTime));
  const israelHourMinute = convertToTotalTimeSinceMidnight(getSplitIsraelHourMinute());
  return startTime < israelHourMinute && israelHourMinute < endTime;
};

const isOpenNow = (placeDetails: IPlaceDetails) => {
  return !!placeDetails.opening_hours.periods
    .sort((period1, period2) => period1.open.day - period2.open.day)
    .find(period => {
      return isSameDayToday(period.open.day) && isOpen(period.open.time, period.close.time);
    });
};

const AdOpeningHours = (props: IAdOpeningHoursProps) => {
  const placeDetails: any = (Array.isArray(props.placeDetails) && props.placeDetails[0]) || props.placeDetails;
  return (placeDetails && placeDetails.opening_hours && Array.isArray(placeDetails.opening_hours.periods) && placeDetails.opening_hours.periods.length) ? (
    <GenericDetail
      title={<span className={styles.title}>
        שעות פעילות
        (
        {isOpenNow(placeDetails) ?
          <span className={styles.openRightNow}>פתוח עכשיו</span> :
          <span className={styles.closedRightNow}>סגור</span>}
        )
      </span>}
      icon={WatchLaterRoundedIcon}
    >
      {placeDetails.opening_hours.periods
        .sort((period1, period2) => period1.open.day - period2.open.day)
        .map(period => {
          //({day: period.open.day, start: period.open.time, end: period.close.time})
          const isSameDay = isSameDayToday(period.open.day);
          return <GenericDetail
            key={period.open.day}
            title={dayOfWeekNames[period.open.day % 7]}
            icon={isSameDay ? FiberManualRecordRoundedIcon : FiberManualRecordOutlinedIcon}
            className={classNames({
              [styles.openingHoursPeriod]: true,
            //  [styles.openingHoursPeriodOpen]: open,
            })}
          >
            {[formatPeriodTime(period.open.time), formatPeriodTime(period.close.time)].join(' - ')}
          </GenericDetail>;
        })
      }
    </GenericDetail>
  ) : null;
};

AdOpeningHours.defaultProps = {};
export default AdOpeningHours;
